import { Status, Statuses } from "azure-devops-ui/Status";
import * as React from "react";
import { css } from "azure-devops-ui/Util";

const StateIcon: React.FC<{ state: string }> = props => {
  switch (props.state) {
    case "To Do":
      return <Status {...Statuses.Queued} size={"16" as any} />;

    case "Doing":
      return <Status {...Statuses.Waiting} size={"16" as any} />;

    case "Done":
      return <Status {...Statuses.Success} size={"16" as any} />;

    default:
      return <div style={{ marginLeft: -4 }} />;
  }
};

export const State: React.FC<{ className?: string; state: string }> = props => {
  return (
    <div className={css("flex-row flex-center", props.className)}>
      <StateIcon state={props.state} />
      <div style={{ marginLeft: 8 }}>{props.state}</div>
    </div>
  );
};
